<template>
  <div class="law-cases-editor-header">
    <icon size="16" type="md-document" class="ms-help" />
    <span style="margin-left: 4px" class="ms-help">
      {{ `${lawCase.id ? "Редактирование" : "Создание"} судебного дела` }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['law-case']
}
</script>

<style lang="less">
.lc-editor-header {
  display: flex;
  align-items: center;
}
</style>
